import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import global from "../store/global";
import routesModel from "./routes";
import { jwtDecode } from "jwt-decode";

Vue.use(VueRouter);

const routes = [...routesModel];

const router = new VueRouter({
    mode: "history",
    // mode: "hash",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    // title tap changer
    // window.document.title = to.name ? to.name : "Hotel";

    global.dispatch("reset");

    if (to.matched.some((r) => r.meta.requireAuth)) {
        const token = store.state.auth.accessToken;

        if (!token) {
            return next("/login");
        }

        try {
            // Decode JWT token
            const decodedToken = jwtDecode(token);
            const currentTime = Date.now() / 1000;

            // Check token expiration
            if (decodedToken.exp && decodedToken.exp < currentTime) {
                console.log("Token is expired");
                store.dispatch("auth/logout");
                return next("/login");
            }

            // Check role-based access
            if (to.meta.auth && to.meta.auth.length > 0) {
                // Get roles from JWT token (it's in the 'role' property as array)
                const userRoles = decodedToken.role || [];

                // Check if user has any of the required roles
                const hasAccess = to.meta.auth.some((requiredRole) =>
                    userRoles.includes(requiredRole)
                );

                if (!hasAccess) {
                    // Show access denied toast
                    store.dispatch("toastification/setToast", {
                        message:
                            "تم رفض الوصول - ليس لديك صلاحية لدخول هذه الصفحة",
                        type: "error",
                    });
                    return next("/forbidden");
                }
            }
        } catch (error) {
            // Token decode failed, try to get roles from userData as fallback
            console.error("Token validation error:", error);

            if (store.state.auth.userData) {
                console.log(
                    "Token decode failed but userData exists, proceeding..."
                );

                // Check roles from userData instead
                if (to.meta.auth && to.meta.auth.length > 0) {
                    const userRoles =
                        store.state.auth.userData?.userData?.roles ||
                        store.state.auth.userData?.roles ||
                        [];

                    const hasAccess = to.meta.auth.some((requiredRole) =>
                        userRoles.includes(requiredRole)
                    );

                    if (!hasAccess) {
                        console.log(
                            "Access denied via userData. User roles:",
                            userRoles,
                            "Required:",
                            to.meta.auth
                        );
                        // Show access denied toast
                        store.dispatch("toastification/setToast", {
                            message:
                                "تم رفض الوصول - ليس لديك صلاحية لدخول هذه الصفحة",
                            type: "error",
                        });
                        return next("/forbidden");
                    }
                }
            } else {
                // No userData and token decode failed, logout
                store.dispatch("auth/logout");
                return next("/login");
            }
        }
    }
    next();
});

export default router;
